import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.headers.get('skip')) {
      return next.handle(req);
    } else {
      let headers = new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'X-App': 'BACKOFFICE',
        });


      const modifiedRequest = req.clone({ headers: headers });
      return next.handle(modifiedRequest);
    }
  }
}
